import React from 'react'
import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'

import {OfferSecondaryLayoutVariant} from '@daedalus/core/src/offer/types/OfferLayout'

interface Props {
  variant: OfferSecondaryLayoutVariant
}

export const CtaComponent = ({variant}: Props) => {
  const isSecondaryWithoutRoomName = variant === 'SecondaryWithoutRoomName'

  return (
    <Box
      data-id="ArrowIcon"
      hasMirror
      marginLeft={isSecondaryWithoutRoomName ? 's100' : 's200'}
      color={
        isSecondaryWithoutRoomName
          ? 'content.neutral.c950'
          : 'content.neutral.c600'
      }
    >
      <Icon
        name="ChevronRight"
        size={isSecondaryWithoutRoomName ? 'xs' : 'sm'}
        colorPath="content.neutral.c600"
      />
    </Box>
  )
}
